import { useEffect } from 'react';

import { useAnalyticsProps } from '@/hooks/useAnalyticsProps';
import { setGlobalAnalyticsProps } from '@/lib/analytics';

/**
 * Syncs the user's plan, contact count bucket, and message count bucket
 * into the Plausible global custom properties so every tracked event
 * carries these dimensions automatically.
 *
 * Renders nothing - mount once inside the authenticated tree.
 */
export function AnalyticsPropsSync() {
  const props = useAnalyticsProps();

  useEffect(() => {
    if (props) {
      setGlobalAnalyticsProps({ ...props });
    }
  }, [props]);

  return null;
}
